import React from "react";
import { Navigate } from "react-router-dom";
import Config from "../config";
// Profile
import UserProfile from "../pages/Authentication/user-profile";
import UserChangePassword from "../pages/Authentication/user-change-password";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Investor from "../pages/Investor/index";
import Dashboard from "../pages/Dashboard/index";
import InvestorDetail from "../pages/Investor/investorDetail";
import InvestorEdit from "../pages/Investor/edit";
import InvestorDossierSouscription from "../pages/Investor/formDossierSouscription";
import InvestorNew from "../pages/Investor/submitInvestor";
import Reservation from "../pages/Reservation/index";
import ReservationDetail from "../pages/Reservation/reservationDetail";
import ReservationEdit from "../pages/Reservation/edit";
import ReservationNew from "../pages/Reservation/new";
import ReservationEnCours from "../pages/ReservationEnCours/index";
import ReservationEnCoursDetail from "../pages/ReservationEnCours/reservationEnCoursDetail";
import ReservationEnCoursEdit from "../pages/ReservationEnCours/edit";
import SuiviSouscriptions from "../pages/SuiviSouscriptions/index";
import Souscription from "../pages/Souscription/index";
import SouscriptionDetail from "../pages/Souscription/souscriptionDetail";
import SouscriptionEdit from "../pages/Souscription/edit";
import Erreur403 from "../pages/Utility/pages-403";
import Erreur500 from "../pages/Utility/pages-500";
import Erreur404 from "../pages/Utility/pages-404";
import SouscriptionNew from "../pages/Souscription/new";
import Participation from "pages/Participations/index";

import Pmes from "../pages/Pmes/index";
import PmeDetail from "../pages/Pmes/pmeDetail";
import PmeEdit from "../pages/Pmes/edit";
import PmeNew from "../pages/Pmes/new";
import DupliquerPme from "../pages/Pmes/dupliquer";
import ExportComptablePme from "../pages/Pmes/exportComptable";
import Investissement from "../pages/Investissements/index";
import InvestissementDetail from "../pages/Investissements/investissementDetail";
import InvestissementEdit from "../pages/Investissements/edit";
import MesCGPS from "../pages/MesCGPS/index";
import MesCGPSDetail from "../pages/MesCGPS/cgpDetail";
import MesCgpsEdit from "../pages/MesCGPS/edit";
import MesCgpsNew from "../pages/MesCGPS/new";
import Partenaires_cgps from "../pages/Partenaires_cgps/index";
import Partenaires_cgpsDetail from "../pages/Partenaires_cgps/cgpDetail";
import Partenaires_cgpsEdit from "../pages/Partenaires_cgps/edit";
import Partenaires_cgpsNew from "../pages/Partenaires_cgps/new";
import PartenairesExp from "../pages/Partenaires_exploitants/index";
import PartenairesExpDetail from "../pages/Partenaires_exploitants/expDetail";
import PartenairesExpEdit from "../pages/Partenaires_exploitants/edit";
import PartenairesExpNew from "../pages/Partenaires_exploitants/new";
import PartenairesIndu from "../pages/Partenaires_industriels/index";
import PartenairesInduDetail from "../pages/Partenaires_industriels/industrielDetail";
import PartenairesInduNew from "../pages/Partenaires_industriels/new";
import PartenairesInduEdit from "../pages/Partenaires_industriels/edit";
import PartenairesDp from "../pages/Partenaires_dproduits/index";
import PartenairesDpDetail from "../pages/Partenaires_dproduits/pdpDetail";
import PartenairesDpEdit from "../pages/Partenaires_dproduits/edit";
import PartenairesDpNew from "../pages/Partenaires_dproduits/new";
import ModeleInvest from "../pages/ModeleInvestisseur/index";
import ModeleInvestDetail from "../pages/ModeleInvestisseur/modeleInvestisseurDetail";
import ModeleInvestEdit from "../pages/ModeleInvestisseur/edit";
import ModeleInvestNew from "../pages/ModeleInvestisseur/new";
import ModeleReserv from "../pages/ModeleReservation/index";
import ModeleReservDetail from "../pages/ModeleReservation/modeleReservationDetail";
import ModeleReservEdit from "../pages/ModeleReservation/edit";
import ModeleReservNew from "../pages/ModeleReservation/new";

import ModeleSoucription from "../pages/ModeleSouscription/index";
import ModeleSoucriptionDetail from "../pages/ModeleSouscription/modeleSouscriptionDetail";
import ModeleSoucriptionEdit from "../pages/ModeleSouscription/edit";
import ModeleSoucriptionNew from "../pages/ModeleSouscription/new";

import ModelePmes from "../pages/ModelePmes/index";
import ModelePmesDetail from "../pages/ModelePmes/modelePmesDetail";
import ModelePmesEdit from "../pages/ModelePmes/edit";
import ModelePmesNew from "../pages/ModelePmes/new";

import ModeleInvestissement from "pages/ModeleInvestissement/index";
import ModeleInvestissementDetail from "../pages/ModeleInvestissement/modeleInvestissementDetail";
import ModeleInvestissementEdit from "pages/ModeleInvestissement/edit";
import ModeleInvestissementNew from "pages/ModeleInvestissement/new";
import ModeleLoyer from "pages/ModeleLoyers/index";
import ModeleLoyerDetail from "../pages/ModeleLoyers/modeleLoyerDetail";
import ModeleLoyerEdit from "../pages/ModeleLoyers/edit";
import ModeleLoyerNew from "../pages/ModeleLoyers/new";

import ModeleAugCap from "pages/ModeleAugCap/index";
import ModeleAugCapDetail from "../pages/ModeleAugCap/modeleAugCapDetail";
import ModeleAugCapEdit from "../pages/ModeleAugCap/edit";
import ModeleAugCapNew from "../pages/ModeleAugCap/new";
import ImpressionList from "pages/Impressions/index";
import ImpressionDetail from "pages/Impressions/impressionDetail";
import ImpressionEdit from "pages/Impressions/edit";
import ImpressionNew from "pages/Impressions/new";

const backUrl = Config.backOffice.url;

const authProtectedRoutes = [
  { path: `${backUrl}/fdashboards`, component: <Dashboard /> },
  // //profile
  {
    path: `${backUrl}/mes_informations`,
    component: <UserProfile />,
  },
  {
    path: `${backUrl}/change_password`,
    component: <UserChangePassword />,
  },
  { path: `${backUrl}/forbidden`, component: <Erreur403 /> },
  { path: `${backUrl}/error`, component: <Erreur500 /> },
  { path: `${backUrl}/error404`, component: <Erreur404 /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to={`${backUrl}/fdashboards`} />,
  },
  {
    path: `${backUrl}`,
    exact: true,
    component: <Navigate to={`${backUrl}/fdashboards`} />,
  },
  //Investisseurs routes
  { path: `${backUrl}/investisseurs`, component: <Investor /> },
  { path: `${backUrl}/investisseurs/:id`, component: <InvestorDetail /> },
  {
    path: `${backUrl}/investisseurs/form_dossier_souscription/:investisseur_id`,
    component: <InvestorDossierSouscription />,
  },
  {
    path: `${backUrl}/investisseurs/:id/edit`,
    component: <InvestorEdit />,
  },
  { path: `${backUrl}/investisseurs/new`, component: <InvestorNew /> },
  //Reservations routes
  {
    path: `${backUrl}/reservations`,
    exact: true,
    component: <Reservation />,
  },
  {
    path: `${backUrl}/reservations/:id`,
    component: <ReservationDetail />,
  },
  {
    path: `${backUrl}/reservations/:id/edit`,
    component: <ReservationEdit />,
  },
  {
    path: `${backUrl}/reservations/new`,
    component: <ReservationNew />,
  },
  {
    path: `${backUrl}/reservations_en_cours`,
    component: <ReservationEnCours />,
  },
  {
    path: `${backUrl}/reservations_en_cours/:id`,
    component: <ReservationEnCoursDetail />,
  },
  {
    path: `${backUrl}/reservations_en_cours/:id/edit`,
    component: <ReservationEnCoursEdit />,
  },
  //// Souscriptions
  {
    path: `${backUrl}/Souscriptions`,
    component: <Souscription />,
  },
  {
    path: `${backUrl}/Souscriptions/:id`,
    component: <SouscriptionDetail />,
  },
  {
    path: `${backUrl}/Souscriptions/:id/edit`,
    component: <SouscriptionEdit />,
  },
  {
    path: `${backUrl}/Souscriptions/new`,
    component: <SouscriptionNew />,
  },
  // Partipations
  {
    path: `${backUrl}/mes_participations`,
    component: <Participation />,
  },
  // Pmes
  {
    path: `${backUrl}/pmes`,
    component: <Pmes />,
  },
  {
    path: `${backUrl}/pmes/:id`,
    component: <PmeDetail />,
  },
  {
    path: `${backUrl}/pmes/:id/edit`,
    component: <PmeEdit />,
  },
  {
    path: `${backUrl}/pmes/new`,
    component: <PmeNew />,
  },
  {
    path: `${backUrl}/pmes/:id/dupliquer`,
    component: <DupliquerPme />,
  },
  {
    path: `${backUrl}/pmes/:id/dupliquer`,
    component: <DupliquerPme />,
  },
  {
    path: `${backUrl}/pmes/:id/export_comptable_form`,
    component: <ExportComptablePme />,
  },
  // Souscriptions suivis
  {
    path: `${backUrl}/reservations_suivis`,
    component: <SuiviSouscriptions />,
  },
  // Investissements
  {
    path: `${backUrl}/investissements`,
    component: <Investissement />,
  },
  {
    path: `${backUrl}/investissements/:id`,
    component: <InvestissementDetail />,
  },
  {
    path: `${backUrl}/investissements/:id/edit`,
    component: <InvestissementEdit />,
  },
  // CGPS
  {
    path: `${backUrl}/mes_cgps`,
    component: <MesCGPS />,
  },
  {
    path: `${backUrl}/mes_cgps/:id`,
    component: <MesCGPSDetail />,
  },
  {
    path: `${backUrl}/mes_cgps/:id/edit`,
    component: <MesCgpsEdit />,
  },
  {
    path: `${backUrl}/mes_cgps/new`,
    component: <MesCgpsNew />,
  },
  /// Partenaires_cgps
  {
    path: `${backUrl}/partenaires_cgps/`,
    component: <Partenaires_cgps />,
  },
  {
    path: `${backUrl}/partenaires_cgps/:id`,
    component: <Partenaires_cgpsDetail />,
  },
  {
    path: `${backUrl}/partenaires_cgps/:id/edit`,
    component: <Partenaires_cgpsEdit />,
  },
  {
    path: `${backUrl}/partenaires_cgps/new`,
    component: <Partenaires_cgpsNew />,
  },

  /// Partenaires_exploitants
  {
    path: `${backUrl}/partenaires_exploitants/`,
    component: <PartenairesExp />,
  },
  {
    path: `${backUrl}/partenaires_exploitants/:id`,
    component: <PartenairesExpDetail />,
  },
  {
    path: `${backUrl}/partenaires_exploitants/:id/edit`,
    component: <PartenairesExpEdit />,
  },
  {
    path: `${backUrl}/partenaires_exploitants/new`,
    component: <PartenairesExpNew />,
  },

  /// Partenaires_industriels
  {
    path: `${backUrl}/partenaires_industriels/`,
    component: <PartenairesIndu />,
  },
  {
    path: `${backUrl}/partenaires_industriels/:id`,
    component: <PartenairesInduDetail />,
  },
  {
    path: `${backUrl}/partenaires_industriels/:id/edit`,
    component: <PartenairesInduEdit />,
  },
  {
    path: `${backUrl}/partenaires_industriels/new`,
    component: <PartenairesInduNew />,
  },
  /// Partenaires_dproduits
  {
    path: `${backUrl}/partenaires_dproduits/`,
    component: <PartenairesDp />,
  },
  {
    path: `${backUrl}/partenaires_dproduits/:id`,
    component: <PartenairesDpDetail />,
  },
  {
    path: `${backUrl}/partenaires_dproduits/:id/edit`,
    component: <PartenairesDpEdit />,
  },
  {
    path: `${backUrl}/partenaires_dproduits/new`,
    component: <PartenairesDpNew />,
  },
  // Modele Investisseur
  {
    path: `${backUrl}/publipostages_investisseurs`,
    component: <ModeleInvest />,
  },
  {
    path: `${backUrl}/publipostages_investisseurs/:id`,
    component: <ModeleInvestDetail />,
  },
  {
    path: `${backUrl}/publipostages_investisseurs/:id/edit`,
    component: <ModeleInvestEdit />,
  },
  {
    path: `${backUrl}/publipostages_investisseurs/new`,
    component: <ModeleInvestNew />,
  },

  // Modele Reservation
  {
    path: `${backUrl}/publipostages_reservations`,
    component: <ModeleReserv />,
  },
  {
    path: `${backUrl}/publipostages_reservations/:id`,
    component: <ModeleReservDetail />,
  },
  {
    path: `${backUrl}/publipostages_reservations/:id/edit`,
    component: <ModeleReservEdit />,
  },
  {
    path: `${backUrl}/publipostages_reservations/new`,
    component: <ModeleReservNew />,
  },

  // Modele Souscription
  {
    path: `${backUrl}/publipostages_souscriptions`,
    component: <ModeleSoucription />,
  },
  {
    path: `${backUrl}/publipostages_souscriptions/:id`,
    component: <ModeleSoucriptionDetail />,
  },
  {
    path: `${backUrl}/publipostages_souscriptions/:id/edit`,
    component: <ModeleSoucriptionEdit />,
  },
  {
    path: `${backUrl}/publipostages_souscriptions/new`,
    component: <ModeleSoucriptionNew />,
  },

  // Modele Pmes
  {
    path: `${backUrl}/publipostages_pmes`,
    component: <ModelePmes />,
  },
  {
    path: `${backUrl}/publipostages_pmes/:id`,
    component: <ModelePmesDetail />,
  },
  {
    path: `${backUrl}/publipostages_pmes/:id/edit`,
    component: <ModelePmesEdit />,
  },
  {
    path: `${backUrl}/publipostages_pmes/new`,
    component: <ModelePmesNew />,
  },

  // Modele Augmentation de capital
  {
    path: `${backUrl}/publipostages_augmentation_capitals`,
    component: <ModeleAugCap />,
  },
  {
    path: `${backUrl}/publipostages_augmentation_capitals/:id`,
    component: <ModeleAugCapDetail />,
  },
  {
    path: `${backUrl}/publipostages_augmentation_capitals/:id/edit`,
    component: <ModeleAugCapEdit />,
  },
  {
    path: `${backUrl}/publipostages_augmentation_capitals/new`,
    component: <ModeleAugCapNew />,
  },

  // Modele Investissement
  {
    path: `${backUrl}/publipostages_investissements`,
    component: <ModeleInvestissement />,
  },
  {
    path: `${backUrl}/publipostages_investissements/:id`,
    component: <ModeleInvestissementDetail />,
  },
  {
    path: `${backUrl}/publipostages_investissements/:id/edit`,
    component: <ModeleInvestissementEdit />,
  },
  {
    path: `${backUrl}/publipostages_investissements/new`,
    component: <ModeleInvestissementNew />,
  },

  // Modele Loyer
  {
    path: `${backUrl}/publipostages_loyers`,
    component: <ModeleLoyer />,
  },
  {
    path: `${backUrl}/publipostages_loyers/:id`,
    component: <ModeleLoyerDetail />,
  },
  {
    path: `${backUrl}/publipostages_loyers/:id/edit`,
    component: <ModeleLoyerEdit />,
  },
  {
    path: `${backUrl}/publipostages_loyers/new`,
    component: <ModeleLoyerNew />,
  },
  // Impressions
  {
    path: `${backUrl}/impressions`,
    component: <ImpressionList />,
  },
  {
    path: `${backUrl}/impressions/:id`,
    component: <ImpressionDetail />,
  },
  {
    path: `${backUrl}/impressions/:id/edit`,
    component: <ImpressionEdit />,
  },
  {
    path: `${backUrl}/impressions/new`,
    component: <ImpressionNew />,
  },
];

const publicRoutes = [
  { path: `${backUrl}/login`, component: <Login /> },
  { path: `${backUrl}/logout`, component: <Logout /> },
  { path: `${backUrl}/forgot-password`, component: <ForgetPwd /> },
  { path: `${backUrl}/register`, component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
